<template>
    
    <div>
        <div v-if="init">
            <div class="flex">
                <div class="w-10/12">
                    <calendar-view
                        :show-date="showDate"
                        :displayPeriodUom="displayPeriod"
                        :startingDayOfWeek="startingDayOfWeek"
                        :displayWeekNumbers="displayWeekNumbers"
                        :items="vacations"
                        :currentPeriodLabel="currentPeriodLabel"
                        :locale="locale"
                        @click-date="onClickDay"
                        class="">
                        <template #header="{ headerProps }">
                            <calendar-view-header
                                :header-props="headerProps"
                                @input="setShowDate" />
                        </template>
                    </calendar-view>
                </div>
                <div class="w-2/12">
                        <div class="flex p-4 -ml-64">
                            <div class="font-bold mr-4">
                                Period:
                            </div>
                            <div class="flex">
                                <div class="flex items-center">
                                    <input id="week" class="mr-1 cursor-pointer" type="radio" value="week" v-model="displayPeriod">
                                    <label class="cursor-pointer" for="week">Week</label>
                                </div>
                                <div class="flex items-center ml-6">
                                    <input id="month" class="mr-1 cursor-pointer" type="radio" value="month" v-model="displayPeriod">
                                    <label class="cursor-pointer" for="month">Month</label>
                                </div>
                            </div>
                        </div>
                        <div class="px-4">
                            <div class="bg-gray-400 py-1 px-3 mb-3">
                                {{ formatJSDate() }}
                            </div>
                            <div>
                                <div
                                    class="my-1 px-1 text-sm"
                                    style="background-color: #99d57e"
                                    v-for="vacation in selectedDayVacations">
                                    {{vacation.title}}
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        
        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>
    </div>

</template>

<script>
import { db, auth } from "@/firebase";
import { mapState } from "vuex";
import moment from 'moment';
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"

export default {
    
    data() {
        return { 
            showDate: new Date(),
            displayPeriod: 'week',
            displayWeekNumbers: true,
            startingDayOfWeek: 1,
            allVacations: [],
            currentPeriodLabel: 'Today',
            locale: 'en-US',
            dataLoaded: 0
        }
    },

    computed: {
        init() {
            if (this.users && this.dataLoaded) return true;
            return false;
        },

        ...mapState([
            'users'
        ]),

        vacations() {
            var vacations = [];

            if (this.allVacations.length === 0) return vacations;

            vacations = this.allVacations.map(vacation => {
                var vacObj = {
                    id: vacation._key,
                    title: this.getUserName(vacation.user),
                    startDate: this.formatDate(vacation.from),
                    endDate: this.formatDate(vacation.to),
                    classes: ""
                }
                return vacObj
            })

            // filter superadmin
            vacations = vacations.filter(vacation => vacation.title != 'superadmin');

            return vacations;
        },

        selectedDayVacations() {
            return this.vacations.filter(vacation => {
                return moment(this.showDate).isSameOrAfter(vacation.startDate, 'day') && moment(this.showDate).isSameOrBefore(vacation.endDate, 'day');
            })
        }
    },
    
    components: {
        CalendarView,
        CalendarViewHeader,
    },

    methods: {
        setShowDate(d) {
            this.showDate = d;
        },

        onClickDay(d) {
			this.showDate = d
		},

        formatDate(date) {
            return moment(date.seconds * 1000).toDate();
        },

        formatJSDate() {
            return moment(this.showDate).format('DD.MM.YYYY');
        },

        getUserName(uid) {
			return this.users.find(user => user.uid === uid).name
        },
    },

    created() {

        if (!this.users) this.$store.dispatch('getUsers')

        db
            .collection('vacations')
            //.where('year', '==', this.date.year)
            .onSnapshot(query => {
                var vacations = []
                query.forEach(function (doc) {
                    var vacation = doc.data()
                    vacation._key = doc.id
                    vacations.push(vacation)
                });
                this.allVacations = vacations;
                this.dataLoaded = 1;
            })

    }
}
</script>

<style scope>
.cv-header {
    border-width: 0 !important;
}
.nextYear,
.previousYear {
    display: none !important;
}
.cv-header-nav, .cv-header .periodLabel {
	margin: .1em 1em 0.5em .1em !important;
}
.cv-header-nav button {
    background-color: rgb(42, 67, 101) !important;
    color: white !important;
}
.cv-header button {
    border-color: rgb(237, 242, 247) !important;
}
.currentPeriod {
    background-color: rgb(72, 103, 147) !important;
}
.cv-header-day {
    background-color: rgb(203, 213, 224) !important;
    padding: 0.5em 0 !important;
}
.cv-weeknumber {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background-color: #eee !important;
}
.cv-weeknumber span {
    font-size: 12px !important;
}
.cv-day {
    background-color: white !important;
}
.cv-day.today {
    background-color: #fcefe8 !important;
}
.cv-day:hover {
    background-color: #efefef !important;
}
.cv-week {
    min-height: 13vh !important;
}
.period-week .cv-week {
    min-height: 70vh !important;
}
.cv-item {
    background-color: #99d57e !important;
    border: 2px solid white !important;
    font-size: 14px !important;
    padding: 3px !important;
}
.outsideOfMonth .cv-day-number {
    color: #ccc !important;
}
</style>